<template>
  <p class="copyright">
    版权所有：成都运荔枝科技有限公司 备案号：蜀ICP备19017829号-1
  </p>
</template> 

<script>
export default {
  name: 'CopyRight'
};
</script>


<style lang="less" scoped>
.copyright {
  padding: 72px 0 24px 0px;
  color: #999999;
  text-align: center;
}
</style>